<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div id="container" class="apply_st">
        <div class="inner">
          <div v-on-clickaway="close" class="box_wrap">
            <div class="box tac">
              <div ref="focus" class="box_title">
                <h2 class="col_choice">학부(학과) 선택</h2>
                <!-- <span>{{ groupsUnicolNm }}</span>
                <span>{{ groupsUnicolCd }}</span> -->
                <button class="close" @click="close">
                  <img src="@/assets/images/login_join/close.png" alt="닫기" />
                </button>
              </div>
              <div class="search_area">
                <form @submit.prevent="searchDivi">
                  <legend class="blind">검색</legend>
                  <div class="search_box">
                    <label for="search-book" class="lab hidden">
                      {{ $t('views.help.faq.2181') }}
                    </label>
                    <input
                      id="search-book"
                      :value="searchNm"
                      type="text"
                      placeholder="학부(학과)를 선택해 주세요."
                      name="col_put"
                      maxlength="90"
                      @input="handleInput"
                    />
                    <button
                      type="button"
                      class="btn_search"
                      @click="searchDivi"
                    >
                      <span class="svg_search"></span>
                      <span class="blind">검색</span>
                    </button>
                  </div>
                  <p class="info">
                    찾으시는 학부(학과명)가 없으면 직접 검색해주세요.
                  </p>
                  <!-- <p>
                    대학교 수정은 학교선택 시점으로부터 30일 후에 가능하니
                    정확히 입력해 주세요.
                  </p> -->
                </form>
              </div>
              <div v-if="selectedDivi.length > 0" class="pick_list flex">
                <div class="pick_leng">
                  총 <span class="point">{{ selectedDivi.length }}</span
                  >개
                </div>
                <ul class="pick_divi_wrap">
                  <li
                    v-for="(d, i) in selectedDivi"
                    :key="i + 'arr'"
                    class="pick_divi"
                  >
                    <span class="diviNm">{{ limitText(d.deptName, 10) }}</span>
                    <span class="white_close" @click="cancel(i)">
                      <img
                        src="@/assets/images/login_join/white_close.png"
                        alt="취소"
                      />
                    </span>
                  </li>
                </ul>
              </div>
              <div class="uniList">
                <div class="pd_wrap">
                  <h3>
                    <span style="flex: 1;">학부(학과)명</span>
                    <!-- <span style="flex: 3;">위치</span>
                      <span style="flex: 1;">연락처</span> -->
                  </h3>
                </div>
                <div class="scroll_wrap">
                  <div
                    v-if="getDepartmentsList.length === 0"
                    class="flex-center"
                  >
                    <span v-if="searchNm.length > 0" class="non_divi">
                      검색결과가 없습니다.
                    </span>
                    <span v-else class="non_divi">
                      학부/학과 목록이 없습니다.
                    </span>
                    <span
                      v-if="searchNm.length > 0"
                      class="style"
                      @click="requestDivi(searchNm)"
                    >
                      '{{ searchNm }}'로 추가하기
                    </span>
                    <div>
                      <p class="sentence">
                        원하는 학부/학과가 목록에 없을 경우 직접 입력할 수
                        있습니다. <br />
                        학부/학과명을 검색창에 입력 후 검색해 주세요.
                      </p>
                    </div>
                  </div>
                  <ul v-else ref="diviBox">
                    <li
                      v-for="(school, i) in getDepartmentsList"
                      :key="i + 'arr'"
                    >
                      <label :for="'divi_' + i" class="divi">
                        <input
                          v-model="selectedDivi"
                          :value="school"
                          type="checkbox"
                          :id="'divi_' + i"
                        />
                        <span style="flex: 1;">
                          {{ school.deptName }}
                        </span>
                      </label>
                      <!-- <span style="flex: 3;">{{ shool.address }}</span>
                        <span style="flex: 1;">{{ shool.telNo }}</span> -->
                    </li>
                  </ul>
                </div>
              </div>
              <button
                class="choice_complete"
                :class="{ dull: selectedDivi.length == 0 }"
                :disabled="selectedDivi.length == 0"
                @click="savePick"
              >
                선택완료
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
// import EmptyData from '../common/EmptyData.vue'
// import axios from '@/store/axios'

export default {
  name: 'DepartmentModal',
  // components: { EmptyData },
  props: {
    groupsUnicolNm: {
      type: String,
      required: true
    },
    groupsUnicolCd: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      searchNm: '',
      isShowModal: false,
      showErrorModal: false,
      currentPage: 1,
      applyPerPage: 10,
      modalTitleTxt: '',
      isDigging: false,
      searchTp: '',
      selectedDivi: []
    }
  },
  computed: {
    ...mapGetters(['getDepartmentsList'])
  },
  mounted() {
    this.defaultDivi = this.getDepartmentsList

    this.searchDivi()
  },
  methods: {
    async searchDivi() {
      // 공백문자 제거 후 빈 문자열 체크
      const trimmedSearchNm = this.searchNm.trim()
      this.currentPage = 1
      this.$refs.diviBox?.scrollTo && this.$refs.diviBox.scrollTo(0, 0)
      this.isDigging = true
      try {
        await this.$store.dispatch('fetchDepartmentsByUniversity', {
          univCode: this.groupsUnicolCd,
          searchKeyword: trimmedSearchNm
        })
      } catch (err) {
        console.log(err)
      }
    },
    limitText(text, maxLength) {
      if (!text) return ''
      if (text.length <= maxLength) {
        return text
      }
      return text.slice(0, maxLength) + '...'
    },
    savePick() {
      const diviForm = this.selectedDivi.map((e) => ({
        deptName: e.deptName,
        deptSeq: e.deptSeq
      }))
      this.$emit('departInfo', diviForm)
    },
    cancel(i) {
      this.selectedDivi.splice(i, 1)
    },
    handleInput(e) {
      this.searchNm = e.target.value
      if (this.searchNm === '' || this.searchNm.length === 0) {
        this.searchDivi()
      }
    },
    requestDivi(searchNm) {
      const diviForm = {
        deptName: searchNm,
        deptSeq: null
      }

      // 이미 동일한 deptName을 가진 항목이 있는지 확인
      const isDuplicate = this.selectedDivi.some(
        (item) => item.deptName === searchNm
      )

      if (isDuplicate) {
        this.searchNm = ''
        this.searchDivi()
        return alert('이미 추가한 학과명입니다.')
      }

      this.selectedDivi.push(diviForm)
      this.searchNm = ''
      this.searchDivi()
    },
    closeModal() {
      this.isShowModal = false
      this.showErrorModal = false
    },
    toggleErrorModal() {
      this.modalTitleTxt = '알림창'
      this.showErrorModal = !this.showErrorModal
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
<style src="@/assets/css/meta_book_style.css" scoped></style>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
@import '../../../src/assets/scss/_variables.scss';
.pick_list::-webkit-scrollbar {
  width: 10px;
  height: 5px;
  border-radius: 10px;
  padding-right: 20px;
}
.pick_list::-webkit-scrollbar-thumb {
  background-color: #555555;
  border-radius: 10px;
}
.pick_list::-webkit-scrollbar-track {
  border-radius: 10px;
}
.uniList ul::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  border-radius: 10px;
}
.uniList ul::-webkit-scrollbar-thumb {
  width: 5px;
  height: 10px;
  background-color: #555555;
  border-radius: 10px;
}
.flex-center {
  flex-direction: column;
  gap: 20px;
  max-width: 1280px;
  min-height: 240px;
  max-height: 620px;
  margin: 0 auto;
}
.style {
  padding: 10px 20px;
  background: #008df3;
  border-radius: 17px;
  border: none;
  font-family: 'pretendard-light';
  font-weight: 600;
  font-size: 16px;
  color: #fff;
  cursor: pointer;
}
// 학지추가
.uniList ul::-webkit-scrollbar {
  width: 5px;
  height: 10px;
  border-radius: 10px;
  background: #f0f5fa;
}
.uniList ul::-webkit-scrollbar-thumb {
  width: 5px;
  height: 10px;
  background-color: #0f638f;
  border-radius: 10px;
}
.info {
  font-family: 'pretendard-medium';
  margin: 0 0 20px;
  color: #777777;
}
.sentence {
  font-family: 'pretendard-medium';
  line-height: 20px;
  color: #777777;
}
.non_divi {
  display: block;
  font-family: 'pretendard-medium';
  font-size: 17px;
}
.join_st .section .inner {
  margin-bottom: 0;
}
// 학지추가
h2 {
  color: $h_BLUE_01;
}
.pick_list {
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
  // height: 65px;
  padding: 0 20px 10px 0;
  .pick_leng {
    margin-bottom: 10px;
    text-align: left;
    font-weight: 600;
    .point {
      color: #008df3;
    }
  }
  .pick_divi_wrap {
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .pick_divi {
    display: flex;
    align-items: center;
    gap: 5px;
    white-space: nowrap;
    padding: 7px 14px;
    background: #0d99ff;
    border-radius: 22px;
    .diviNm {
      color: #ffffff;
      font-size: 13px;
      line-height: 13px;
      padding-left: 3px;
    }
    .white_close {
      width: 18px;
      height: 18px;
      cursor: pointer;
      > img {
        width: 100%;
        vertical-align: top;
      }
    }
  }
}
.search_area {
  width: 100%;
  margin: 0 auto;
  // padding-right: 20px;
  line-height: 48px;
  border-radius: 12px;
  .search_box {
    position: relative;
    width: 100%;
    height: 56px;
    margin: 0 auto 10px;
    background-color: transparent;
    // border: 1px solid #dddddd;
    border-radius: 8px;
    .btn_search {
      top: 50%;
      transform: translateY(-50%);
      right: 16px;
      .svg_search {
        background-image: url('../../assets/images/login_join/ic_search.png');
        background-size: cover;
      }
    }
    input {
      border: 1px solid #dddddd;
      outline: none;
      width: 100%;
      height: 100%;
      margin: 0 auto;
      padding: 0 16px;
      border-radius: 12px;
      background-color: inherit;
      font-size: 15px;
      letter-spacing: 0;
      color: #333333;
      &::placeholder {
        color: #999999;
      }
      &:focus {
        border: 1px solid #008df3;
      }
    }
  }
}
#container {
  min-height: auto;
}
.apply_st {
  width: 100% !important;
  .inner {
    padding: 0;
    .close_btn {
      right: 7%;
    }
    .box_wrap {
      width: 100%;
      max-width: 520px;
      margin: 0 auto;
      padding-bottom: 89px;
      .box {
        width: 100%;
        max-width: 520px;
      }
    }
  }
  .btn_wrap .box_btn {
    width: 150px;
  }
}
.uniList {
  width: 100%;
  margin: 10px 0 10px;
  border-top: none;
  .pd_wrap {
    // padding-right: 20px;
    h3 {
      display: flex;
      align-items: center;
      height: 44px;
      background-color: #f6f6f6;
      border-top: 1px solid #000000;
      span {
        line-height: 23px;
        font-weight: 400;
        font-size: 15px;
        color: #777777;
      }
    }
  }
  .scroll_wrap {
    // padding-right: 5px;
    border-bottom: 1px solid #000000;
    ul {
      max-height: 46vh;
      overflow: auto;
      // padding-right: 10px;
      &::-webkit-scrollbar {
        width: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #555555;
      }
      li {
        display: flex;
        align-items: center;
        gap: 16px;
        height: 56px;
        padding: 0;
        border-bottom: 1px solid #e8e8e8;
        cursor: pointer;
        &:nth-child(1) {
          border-top: 1px solid #d6e7f1;
        }
        .divi {
          display: flex;
          align-items: center;
          width: 100%;
          height: 100%;
          cursor: pointer;
          input {
            display: none;
          }
        }
        span {
          font-family: 'pretendard-medium';
          font-size: 13px;
          letter-spacing: 0;
          line-height: 20px;
          &:nth-child(1) {
            color: #333333;
          }
          &:nth-child(2) {
            white-space: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            text-align: center;
            color: #777777;
          }
        }
      }
    }
  }
}
.svg_search {
  margin: 0 !important;
}
.choice_complete {
  width: 300px;
  height: 56px;
  background: #008df3;
  border-radius: 12px;
  border: none;
  font-family: 'pretendard-medium';
  font-weight: 600;
  font-size: 18px;
  line-height: 56px;
  color: #fff;
  &.dull {
    opacity: 0.5;
  }
}
.ly_alert {
  width: 540px;
  padding: 65px 58px 60px;
}
.ly_alert .ly_inner {
  padding: 0 !important;
  text-align: center;
  background-color: #f0f5fa !important;
}
.ly_alert .ly_inner strong {
  display: block;
  padding-top: 83px;
  padding-bottom: 8px;
}
.ly_alert .ly_inner p {
  margin-top: 0;
  word-break: keep-all;
  letter-spacing: -0.03em;
  font-size: 16px;
  color: #627283;
}
.ly_alert .ly_inner .btnWrap {
  margin-top: 24px;
}
@media (max-width: 1024px) {
  .box_wrap {
    padding: 48px 0px !important;
    border-radius: 20px;
  }
}
@media (max-width: 767px) {
  .box_wrap {
    padding: 20px 0 !important;
    .box_title {
      margin-bottom: 1.35em;
    }
  }
  .uniList ul li {
    padding: 0 10px;
  }
  h3,
  li {
    span:nth-child(3) {
      display: none;
    }
  }
}
#container {
  min-width: 330px;
}
.box_wrap {
  .box_title {
    position: relative;
    margin-bottom: 23px;
    h2.col_choice {
      // padding-right: 20px;
      font-size: 20px;
      color: #000000;
      letter-spacing: 0;
    }
  }
}
.apply_st {
  .inner {
    .box_wrap {
      padding: 20px 20px 20px 20px !important;
      .close {
        position: absolute;
        width: 17px;
        height: 17px;
        top: 5px;
        right: 0;
        > img {
          width: 100%;
        }
      }
    }
  }
}
@media (max-width: 480px) {
  .scroll_wrap {
    ul {
      li {
        span {
          &:nth-child(1) {
            color: #333333;
          }
          &:nth-child(2) {
            white-space: normal;
            color: #777777;
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
